import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  theme: {
    primary: '#ec2f54',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  options: {
    customProperties: true
  },
  iconfont: 'youth-icon',
  icons: {
    add: 'youth-icon-add',
    arrowDown: 'youth-icon-arrow-down',
    arrowLeft: 'youth-icon-arrow-left',
    arrowRight: 'youth-icon-arrow-right',
    arrowStickLeft: 'youth-icon-arrow-stick-left',
    arrowStickRight: 'youth-icon-arrow-stick-right',
    arrowUp: 'youth-icon-arrow-up',
    bell: 'youth-icon-bell',
    bookmarkFilled: 'youth-icon-bookmark-filled',
    bookmarkOutlined: 'youth-icon-bookmark-outlined',
    bookmarkTwoTone: 'youth-icon-bookmark-two-tone',
    calendar: 'youth-icon-calendar',
    camera: 'youth-icon-camera',
    cancelRound: 'youth-icon-cancel-round',
    cancel: 'youth-icon-cancel',
    commentOutlined: 'youth-icon-comment-outlined',
    commentFilled: 'youth-icon-comment-filled',
    confirm: 'youth-icon-confirm',
    coupon: 'youth-icon-coupon',
    feed: 'youth-icon-feed',
    filter: 'youth-icon-filter',
    heartFilled: 'youth-icon-heart-filled',
    heartOutlined: 'youth-icon-heart-outlined',
    heartTwoTone: 'youth-icon-heart-two-tone',
    home: 'youth-icon-home',
    image: 'youth-icon-image',
    images: 'youth-icon-images',
    invisible: 'youth-icon-invisible',
    keyboard: 'youth-icon-keyboard',
    location: 'youth-icon-location',
    menuHamburger: 'youth-icon-menu-hamburger',
    menuEllipsis: 'youth-icon-menu-ellipsis',
    money: 'youth-icon-money',
    more: 'youth-icon-more',
    navArrowLeft: 'youth-icon-nav-arrow-left',
    new: 'youth-icon-new',
    notification: 'youth-icon-notification',
    refresh: 'youth-icon-refresh',
    search: 'youth-icon-search',
    settings: 'youth-icon-settings',
    share: 'youth-icon-share',
    star: 'youth-icon-star',
    store: 'youth-icon-store',
    visible: 'youth-icon-visible',
    wallet: 'youth-icon-wallet',
    write: 'youth-icon-write',
  }
});
